var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLgTrashcan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 52,
    viewBox: "0 0 43 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#EB2358",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.741 8.252L41.741 8.252",
    transform: "translate(-716 -229) translate(716.259 230.748)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M3.252 8.522L3.252 49.252 39.957 49.252 39.957 8.522M9.875 7.955L15.03 0 28.331 0 33.479 7.955M12.586 18.347L12.586 38.347M21.586 18.347L21.586 38.347M30.586 18.347L30.586 38.347",
    transform: "translate(-716 -229) translate(716.259 230.748)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLgTrashcan);
export default __webpack_public_path__ + "static/media/icon-lg-trashcan.b93cafcb2c5f2f1f2d70700be6e0a58c.svg";
export { ForwardRef as ReactComponent };